import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

import Modal from '@glu/modal-react';

import { WORKSPACES } from 'constants.js';

import RetrieveWireImportMap from './retrieve/retrieveWireImportMap';
import CreateImportMapsWrapper from './create/CreateImportMapsWrapper';
import ViewACHImportMap from './ViewAchImportMap/ViewACHImportMap';
import useStyles from './WireImportActionSwitcher.styles';

const MAP_TYPES = {
  wires: 'wires',
  ach: 'ach'
};

const WireImportActionSwitcherComponent = () => {
  const history = useHistory();
  const { action, id, mapType } = useParams();
  const { content, takeover } = useStyles();

  // mapType: [wires, ach]
  const baseURL = history?.location?.state?.previous || WORKSPACES.PYMTCNTR;
  const [modalVisible, setModalVisibility] = useState(false);

  const actions = useMemo(
    () => ({
      view: action === 'view' && id,
      create: action === 'create' && !id,
      modify: action === 'modify' && id
    }),
    [action, id]
  );

  useEffect(() => {
    const shouldShowModal = Object.keys(actions).some((x) => actions[x]);

    setModalVisibility(shouldShowModal);
  }, [actions]);

  const closeModal = () => {
    history.push({ pathname: baseURL });
  };

  const viewProps = {
    mapId: parseInt(id, 10),
    closeModal
  };

  return (
    <Modal
      classes={{ takeover, content }}
      dataQa="action-switcher-modal"
      onClose={closeModal}
      open={modalVisible}
      takeover
    >
      <>
        {actions.view && mapType === MAP_TYPES.ach && (
          <ViewACHImportMap closeModal={closeModal} mapCode={id} />
        )}
        {actions.view && mapType === MAP_TYPES.wires && <RetrieveWireImportMap {...viewProps} />}
        {actions.create && <CreateImportMapsWrapper {...viewProps} />}
        {actions.modify && (
          <CreateImportMapsWrapper
            {...(mapType === MAP_TYPES.ach ? { mapCode: id } : {})}
            {...viewProps}
            modify
          />
        )}
      </>
    </Modal>
  );
};

export default WireImportActionSwitcherComponent;
